import { render, staticRenderFns } from "./DevBannersView.vue?vue&type=template&id=5f55e53d&scoped=true"
import script from "./DevBannersView.vue?vue&type=script&lang=ts"
export * from "./DevBannersView.vue?vue&type=script&lang=ts"
import style0 from "./DevBannersView.vue?vue&type=style&index=0&id=5f55e53d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f55e53d",
  null
  
)

export default component.exports